import React, { PureComponent } from 'react';

import NavigationIcon from 'components/icons/NavigationIcon';
import SuggestionsList from './SuggestionsList';
import LoadingDots from 'components/LoadingDots';
import { Translator } from 'Translator';

const CSS = require('./SearchNearbyBlock.less');

interface SearchNearbyBlockProps {
  cities: any[];
  loading: boolean;
  triggerSearch: () => void;
  onSelect: (location: any) => void;
}

export default class SearchNearbyBlock extends PureComponent<SearchNearbyBlockProps> {

  renderContent() {
    const { cities } = this.props;
    return (
      <div>
        {
          cities.length === 0 ?
            this.renderSearchButton() :
            this.renderResultsList()
        }
      </div>
    );
  }

  renderSearchButton() {
    const { triggerSearch } = this.props;
    return (
      <div className={CSS.NearByContainer}>
        <button type="button" className={CSS.NearByButton} onClick={triggerSearch}>
          <NavigationIcon
            width={12}
            height={12}
            className={CSS.NearByIcon}
          />
          <span className={CSS.NearByText}>
            {Translator.translate('UserEnvironment.LocationFilter.searchNearby', {}, true, 'Search nearby')}
          </span>
        </button>
      </div>
    );
  }

  renderResultsList() {
    const { cities, onSelect } = this.props;
    return (
      <SuggestionsList
        suggestionType={'nearbydestinations'}
        title={Translator.translate('UserEnvironment.LocationFilter.nearbyDestinations', {}, true, 'Nearby Destinations')}
        onSuggestionChange={onSelect}
        suggestions={cities}
      />
    );
  }

  render() {
    const { loading } = this.props;
    if (loading) {
      return <LoadingDots/>;
    }
    return this.renderContent();
  }

}
